import { CondominiumDetails } from "components/Condominiums/CondominiumDetails";

export const ViewCondominium = () => {
  return (
    <CondominiumDetails />
  );
};
